import { ReactElement } from 'react';
import classes from './TabNavigation.module.css';

export type Tab<T extends string = string> = {
  readonly id: T;
  readonly label: string;
};

type TabNavigationProps<T extends string> = {
  readonly tabs: readonly Tab<T>[];
  readonly activeTab: T;
  readonly onTabChange: (tabId: T) => void;
};

export const TabNavigation = <T extends string>({
  tabs,
  activeTab,
  onTabChange,
}: TabNavigationProps<T>): ReactElement => {
  const handleTabClick = (tabId: T) => {
    onTabChange(tabId);
  };

  return (
    <div className={classes.container}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`${classes.tab} ${activeTab === tab.id ? classes.activeTab : ''}`}
          onClick={() => handleTabClick(tab.id)}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-controls={`tabpanel-${tab.id}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
